/* eslint-disable react/no-unescaped-entities */
import styled from "styled-components/macro";

import FnrLoadingBricks from "UI/FnrLoadingBricks";
import { useSharedResizing } from "UI/SharedResizingArea3";

export const Loading = () => {
  return (
    <Wrapper>
      <div
        style={{
          margin: "1.5rem 0",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <FnrLoadingBricks show={true} size={48} />
      </div>
    </Wrapper>
  );
};

export const Component1 = () => {
  const { updateKey } = useSharedResizing();

  return (
    <Wrapper>
      <Content>
        <p>
          To solve the error "Module not found: Error: Can't resolve
          '@emotion/react'", make sure to install the @emotion/react package by
          opening your terminal in
        </p>
        <p>
          To solve the error "Module not found: Error: Can't resolve
          '@emotion/react'", make sure to install the @emotion/react package by
          opening your terminal in
        </p>
        <p>
          To solve the error "Module not found: Error: Can't resolve
          '@emotion/react'", make sure to install the @emotion/react package by
          opening your terminal in
        </p>
        <p>
          To solve the error "Module not found: Error: Can't resolve
          '@emotion/react'", make sure to install the @emotion/react package by
          opening your terminal in
        </p>
        <p>
          To solve the error "Module not found: Error: Can't resolve
          '@emotion/react'", make sure to install the @emotion/react package by
          opening your terminal in
        </p>
        <Row>
          <Button onClick={() => updateKey(2)}>Next</Button>
        </Row>
      </Content>
    </Wrapper>
  );
};

export const Component2 = () => {
  const { updateKey } = useSharedResizing();
  return (
    <Wrapper>
      <Content>
        <p>p1</p>

        <Row>
          <Button onClick={() => updateKey(1)}>Preview</Button>
          <Button onClick={() => updateKey(3)}>Next</Button>
        </Row>
      </Content>
    </Wrapper>
  );
};

export const Component3 = () => {
  const { updateKey } = useSharedResizing();
  return (
    <Wrapper style={{ width: "200px" }}>
      <Content>
        <input type="text" placeholder="name" />
        <input type="text" placeholder="email" />
        <input type="text" placeholder="phone" />
        <input type="text" placeholder="address" />
        <Button onClick={() => updateKey(2)}>Previous</Button>
      </Content>
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  padding: 30px;
  box-sizing: border-box;

  width: 290px;

  @media screen and (min-width: 480px) {
    width: 460px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Row = styled.div`
  display: flex;
`;

export const RowBetween = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  @media (min-width: 580px) {
    flex-direction: row;
    gap: 2rem;
  }
`;

const Button = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 8px;
  background: gray;
  color: white;
`;

export const P = styled.p`
  margin: 0;
`;
